import { AnalyticsEvent } from '../web-analytics/AnalyticsEvent';
import { analyticsTrack } from '../web-analytics/webAnalytics';
import { readCommonConfig } from '../commons/config';
import { insertPathBeforeUrlQuery } from './url-utils';

export const openUrlInNewTab = (
  baseUrl: string,
  analyticData?: {
    analyticsEvent?: AnalyticsEvent;
    properties?: object;
  },
  path?: string
) => {
  if (analyticData?.analyticsEvent) {
    analyticsTrack(analyticData.analyticsEvent, analyticData.properties ?? {});
  }
  const url = path ? insertPathBeforeUrlQuery(baseUrl, path) : baseUrl;
  const target = readCommonConfig().useSameTab ? '_self' : '_blank';
  const features = 'noopener,noreferrer';
  window.open(url, target, features);
};
